(function(angular){
	'use strict';

	angular
		.module('offeringCircularsModule')
		.controller('OfferingCirculars', [
			'globalConfig',
			'localStorageFactory',
			'mixpanelFactory',
			OfferingCircularsFunction
		]);

	function OfferingCircularsFunction(
		globalConfig,
		localStorageFactory,
		mixpanelFactory) {

		var offeringCirculars = this;
		offeringCirculars.showLandingModuleAb = false;
		var localStorageKey = 'com.fundrise.oc.show-landing';
		var mixpanelProperties = {};

		if(globalConfig.isAnonymous) {
			offeringCirculars.showLandingModuleAb = localStorageFactory.getItemAsBoolean(localStorageKey);
			if (angular.isUndefined(offeringCirculars.showLandingModuleAb)) {
				offeringCirculars.showLandingModuleAb = Math.floor(Math.random() * 2) === 1;
				localStorageFactory.setItem(localStorageKey, offeringCirculars.showLandingModuleAb);
			}
			mixpanelProperties['Landing Shown'] = offeringCirculars.showLandingModuleAb;
		}
		
		mixpanelFactory.track('eREIT Offering Circulars Page Viewed', mixpanelProperties);
	}
})(window.angular);